import { useState, useEffect, useRef } from 'react'
// TextField added srini - 21-01-25
import { Grid, Typography, TextField, useMediaQuery, FormControl, InputLabel, MenuItem, Select, Card, CardContent, List, ListItem, ListItemText, Box, Pagination, Button } from '@mui/material'

import { withStyles } from '@material-ui/core/styles'
import styles from './mobileFranchiseDashboardStyles.js'

import { httpRequest } from '../../../../ui-utils/api'
import { backendHosts, apiUrl } from '../../../../ui-utils/apiConfig'

import Vector1 from '../../../../ui-assets/Vector1.svg'
import snackError from '../../../../helpers/snackError.js' // added by srini on 16-01-25

const WebView = ({ classes, dispatch }) => {
    const isSmallScreen = useMediaQuery('(max-width: 450px)')

    const [selectFranchise, setSelectedFranchise] = useState("")
    const [data, setData] = useState({})
    const [selectedCard, setSelectedCard] = useState('')
    const [viewData, setViewData] = useState([])
    const [mPage, setmPage] = useState(1)
    const [displayData, setDisplayData] = useState([])
    const [brokerage, setBrokerage] = useState([])
    const [franchiseeList, setFranchiseeList] = useState([])
    const [searchQuery, setSearchQuery] = useState('') // srini - 21-01-25
    const [totalCount, setTotalCount] = useState(viewData.length) // srini - 21-01-25
    

    const totalBrokerage = brokerage.reduce((sum, item) => sum + item.brokerage, 0)
    const agentRole = JSON.parse(localStorage.getItem('agentRole'))
    const tableRef = useRef(null) // added by srini on 20-01-25

    useEffect(() => {
        // search query - srini - 21-01-25
        const filteredData = searchQuery
            ? viewData.filter(item => {
                if (selectedCard === 'in_progress') {
                    return (
                        item?.email?.toLowerCase().includes(searchQuery) ||
                        item?.phone?.toLowerCase().includes(searchQuery) ||
                        item?.stage?.toLowerCase().includes(searchQuery) ||
                        item?.created_on?.toLowerCase().includes(searchQuery) ||
                        item?.updated_on?.toLowerCase().includes(searchQuery) // search on acop by srini - 22-01-25
                    )
                }
                if (selectedCard === 'transaction') {
                    return (
                        item?.client_id?.toLowerCase().includes(searchQuery) ||
                        item?.last_activity_date?.toLowerCase().includes(searchQuery) ||
                        (typeof item?.available_margin === 'string' &&
                            item?.available_margin.toLowerCase().includes(searchQuery)) ||
                        (item?.available_margin &&
                            item?.available_margin.toString().toLowerCase().includes(searchQuery))
                    )
                }
                if (selectedCard === 'completed') {
                    return item?.last_activity_date?.toLowerCase().includes(searchQuery)
                }
                if (selectedCard === 'brokerage') {
                    return item?.trading_date?.toLowerCase().includes(searchQuery)
                }
                return false
            })
            : viewData
        const paginatedData = filteredData.slice((mPage - 1) * 10, mPage * 10)

        setDisplayData(paginatedData)
        setTotalCount(filteredData.length)
    }, [mPage, viewData, searchQuery, selectedCard])


    useEffect(() => {
        const franchiseCode = JSON.parse(localStorage.getItem("sipRegData")).franchaise_list
        // srini - 21-01-25
        if (Array.isArray(franchiseCode) && franchiseCode.length > 0) {
            setFranchiseeList(franchiseCode)
        } else if (!agentRole.includes(2)) {
            (async () => {
                // code correction by srini on 16-01-25
                try {
                    const franchaiseData = await httpRequest({
                        endPoint: `${backendHosts.ADMIN}${apiUrl.franchiseList}`,
                        method: "get",
                        instance: "instanceOne",
                    })
                    if (franchaiseData.status === 200) {
                        setFranchiseeList(franchaiseData.data.map((item) => item.franchisee_code))
                    }
                    else if (franchaiseData.error) {
                        console.log('Error in Franchaise List API', franchaiseData.error)
                        dispatch({ type: 'SET_SHOW_ERROR', payload: true })
                        dispatch({ type: 'SET_ERROR', payload: 'Internal Server Error.' })
                        dispatch({ type: 'SET_MY_SNACK', payload: snackError.myError })
                    }
                } catch (error) {
                    console.log('Error in Franchaise List API', error)
                    dispatch({ type: 'SET_SHOW_ERROR', payload: true })
                    dispatch({ type: 'SET_ERROR', payload: 'Internal Server Error.' })
                    dispatch({ type: 'SET_MY_SNACK', payload: snackError.myError })
                }
            })()
        }
    }, [])

    // added by srini on 20-01-25
    useEffect(() => {
        if (selectedCard) {
            const interval = setInterval(() => {
                if (tableRef.current) {
                    tableRef.current.scrollIntoView({ behavior: 'smooth', block: 'start'})
                    clearInterval(interval)
                }
            }, 50)
        }
    }, [selectedCard])
    

    const sortedData = (data, value) => {
        const result = data.sort((a, b) => {
            const dateA = a[value] ? new Date(a[value]) : new Date(0)
            const dateB = b[value] ? new Date(b[value]) : new Date(0)

            // If the date parsing fails, treat it as an invalid date (use new Date(0) for comparison)
            if (isNaN(dateA.getTime())) {
                console.error(`Invalid date: ${a[value]}`)
                return -1 // Invalid date in a comes first
            }
            if (isNaN(dateB.getTime())) {
                console.error(`Invalid date: ${b[value]}`)
                return 1 // Invalid date in b comes first
            }
            return dateB - dateA
        })

        return result
    }

    const handleChange = async (event) => {
        const value = event.target.value
        setSelectedFranchise(value)
        setDisplayData([])
        setSelectedCard('')

        let refcodePayload = ""
        if (value === 'ALL') {
            refcodePayload = franchiseeList.join(",")
        } else {
            refcodePayload = value
        }

        try {
            // code updated by srini on 16-01-25
            const franchiseResult = await httpRequest({
                endPoint: `${backendHosts.CRM}${apiUrl.proxyCheck}`,
                method: "post",
                instance: "instanceOne",
                requestBody: {
                    "u": `admin-reports-backend${apiUrl.franchiseSts}`,
                    "m": "POST",
                    "h": { "x-api-key": "08cd98f3-7aa0-4390-92d6-e952e672a116" },
                    "d": { "refcode": refcodePayload }
                },
            })

            const franchiseBrokerage = await httpRequest({
                endPoint: `${backendHosts.CRM}${apiUrl.proxyCheck}`,
                method: "post",
                instance: "instanceOne",
                requestBody: {
                    "u": `admin-reports-backend${apiUrl.franchiseBrokerage}`,
                    "m": "POST",
                    "h": { "x-api-key": "08cd98f3-7aa0-4390-92d6-e952e672a116" },
                    "d": { "refcode": refcodePayload }
                }
            })

            if (franchiseResult.status === 200) {
                setData(franchiseResult)
            } else {
                console.error('Error in fetching Franchisee API:', franchiseResult)
                // added by srini on 16-01-25
                dispatch({ type: 'SET_SHOW_ERROR', payload: true })
                dispatch({ type: 'SET_ERROR', payload: franchiseResult.error }) // srini - 21-01-25
                dispatch({ type: 'SET_MY_SNACK', payload: snackError.myError })
            }

            if (franchiseBrokerage.status === 200) {
                const sortedData = franchiseBrokerage.data.sort((a, b) => {
                    const dateA = new Date(a.trading_date)
                    const dateB = new Date(b.trading_date)
                    return dateB - dateA
                })

                setBrokerage(sortedData)
            } else {
                console.error('Error in fetching Franchisee Brokerage API:', franchiseResult)
                // added by srini on 16-01-25
                dispatch({ type: 'SET_SHOW_ERROR', payload: true })
                dispatch({ type: 'SET_ERROR', payload: franchiseResult.error }) // srini - 21-01-25
                dispatch({ type: 'SET_MY_SNACK', payload: snackError.myError })
            }
        } catch (error) {
            console.error('Error in fetching Franchisee API:', error)
            // added by srini on 16-01-25
            dispatch({ type: 'SET_SHOW_ERROR', payload: true })
            dispatch({ type: 'SET_ERROR', payload: error }) // srini - 21-01-25
            dispatch({ type: 'SET_MY_SNACK', payload: snackError.myError })
        }
    }

    const selectedCardStyle = {
        border: '2px solid #999',
        boxShadow: '0 4px 8px rgba(0, 0, 0, 0.2)',
    }

    const handleSelectCard = (cardType) => {
        setSelectedCard(cardType)

        if (cardType === 'completed') {
            setViewData(sortedData(data.date_wise, 'last_activity_date')) // renamed by srini on 16-01-25
            setmPage(1)
            setSearchQuery('') // srini - 21-01-25
        } else if (cardType === 'in_progress') {
            setViewData(sortedData(data.in_progress_data, 'updated_on'))
            setmPage(1)
            setSearchQuery('') // srini - 21-01-25
        } else if (cardType === 'brokerage') {
            setViewData(brokerage)
            setmPage(1)
            setSearchQuery('') // srini - 21-01-25
        } else if (cardType === 'transaction') {
            setViewData(sortedData(data.completed_data, 'last_activity_date')) // renamed by srini on 16-01-25
            setmPage(1)
            setSearchQuery('') // srini - 21-01-25
        }
    }

    const handlePageChange = (event, value) => {
        setmPage(value)
    }

    const formatDateTime = () => {
        const now = new Date();

        // Manually format date as DD-MM-YYYY
        const day = String(now.getDate()).padStart(2, '0')
        const month = String(now.getMonth() + 1).padStart(2, '0')
        const year = now.getFullYear()

        // Manually format time as HH:mm:ss
        const hours = String(now.getHours()).padStart(2, '0')
        const minutes = String(now.getMinutes()).padStart(2, '0')
        const seconds = String(now.getSeconds()).padStart(2, '0')

        // Combine date and time into the desired format
        return `${day}-${month}-${year}, ${hours}:${minutes}:${seconds}`;
    }
    // srini - 21-01-25
    const handleSearchChange = (e) => {
        const query = e.target.value.trim().toLowerCase()
        setSearchQuery(query)

        setmPage(1)
    }

    return (
        <Grid container sx={{ margin: "100px 0 0 20px" }}>
            {/* Dashboard Header */}
            <Grid item display="flex" justifyContent="center" alignItems="center">
                <Typography className={classes.fDashText} textAlign="center">
                    Dashboard
                </Typography>
            </Grid>

            {/* Franchise/Branch Dropdown */}
            <Grid container item sx={{ marginTop: '40px' }}>
                <Grid item xs={12} display="flex" alignItems="center" sx={{ marginBottom: '20px' }}>
                    <Typography className={classes.title}>
                        Franchise / Branch:
                    </Typography>
                </Grid>

                <Grid item xs={12}>
                    <FormControl size="small">
                        <InputLabel className={classes.inputColor} id="demo-select-small-label">
                            Select
                        </InputLabel>
                        <Select
                            className={classes.select}
                            labelId="demo-select-small-label"
                            id="demo-select-small"
                            value={selectFranchise}
                            label="Select"
                            onChange={handleChange}
                            displayEmpty
                        >
                            <MenuItem value="ALL" className={classes.intSelText}>All</MenuItem>
                            {franchiseeList.map((item, index) => (
                                <MenuItem key={index} value={item} className={classes.intSelText}>
                                    {item}
                                </MenuItem>
                            ))}
                        </Select>
                    </FormControl>
                </Grid>
            </Grid>

            {/* Agents Dropdown */}
            <Grid container item sx={{ marginTop: '30px' }}>
                <Grid item xs={12} display="flex" alignItems="center" sx={{ marginBottom: '20px' }}>
                    <Typography className={classes.title}>
                        Agents:
                    </Typography>
                </Grid>

                <Grid item xs={12}>
                    <FormControl size="small">
                        <InputLabel className={classes.inputColor} id="demo-select-small-label">
                            All
                        </InputLabel>
                        <Select
                            className={classes.select}
                            labelId="demo-select-small-label"
                            id="demo-select-small"
                            value=""
                            label="All"
                            displayEmpty
                            disabled
                        >
                            <MenuItem value="All" className={classes.mintSelText}>All</MenuItem>
                        </Select>
                    </FormControl>
                </Grid>
            </Grid>

            {/* Period */}
            <Grid item xs={12} display="flex" alignItems="center" sx={{ marginLeft: '4px', marginBottom: '20px', marginTop: '30px' }}>
                <Typography className={classes.title} sx={{ marginRight: '10px', whiteSpace: 'nowrap' }}>
                    Period:
                </Typography>
                <Typography className={classes.title}>
                    2024 -2025
                </Typography>
            </Grid>

            {/* Account Cards (only render if data exists) */}
            {Object.keys(data).length > 0 && (
                <Grid container item sx={{ marginTop: '10px', marginRight: isSmallScreen && '80px' }}>
                    <Grid item xs={12} display="flex" justifyContent="center" alignItems="center">
                        <Typography className={classes.accTitle} sx={{ textAlign: 'center' }}>
                            Accounts
                        </Typography>
                    </Grid>
                </Grid>
            )}

            {/* Account Cards */}
            {Object.keys(data).length > 0 && (
                <Grid container item sx={{ marginTop: '0px' }} spacing={1} justifyContent="center">
                    {/* In Progress Card */}
                    <Grid item xs={12} display="flex" justifyContent={isSmallScreen ? "start" : "center"} alignItems="center">
                        {/* onTouch added - srini - 09-01-25 */}
                        <Card
                            className={classes.cards}
                            style={selectedCard === 'in_progress' ? selectedCardStyle : {}}
                            onTouchStart={() => handleSelectCard('in_progress')}
                        >
                            <CardContent sx={{ display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center' }}>
                                <Typography className={classes.accTitle}>{data.count.in_progress}</Typography>
                                <Typography className={classes.title}>In Progress</Typography>
                            </CardContent>
                        </Card>
                    </Grid>

                    {/* Completed Card */}
                    <Grid item xs={12} display="flex" justifyContent={isSmallScreen ? "start" : "center"} alignItems="center">
                        {/* onTouch added - srini - 09-01-25 */}
                        <Card
                            className={classes.cards}
                            style={selectedCard === 'completed' ? selectedCardStyle : {}}
                            onTouchStart={() => handleSelectCard('completed')}
                        >
                            <CardContent sx={{ display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center' }}>
                                <Typography className={classes.accTitle}>{data.count.completed}</Typography>
                                <Typography className={classes.title}>Completed</Typography>
                            </CardContent>
                        </Card>
                    </Grid>
                </Grid>
            )}

            {/* Brokerage */}
            {(Object.keys(data).length > 0) && (
                <Grid
                    container item
                    xs={isSmallScreen ? 0 : 12}
                    sx={{
                        padding: '30px 20px',
                        borderRadius: '5px',
                        display: 'flex',
                        justifyContent: 'center',
                        alignItems: 'center',
                        color: '#fff',
                        width: '80%'
                    }}
                >
                    {/* Brokerage Label and Value */}
                    <Grid item display="flex" alignItems="center" sx={{ flexDirection: 'column', textAlign: 'center' }}>
                        {/* onTouch added - srini - 09-01-25 */}
                        <Typography className={classes.accTitle} onTouchStart={() => handleSelectCard('brokerage')}>
                            Brokerage:
                            <span className={classes.amtText}> {totalBrokerage.toLocaleString()} </span>
                        </Typography>
                        {/* onTouch added - srini - 09-01-25 */}
                        <Typography className={classes.updtdText} onTouchStart={() => handleSelectCard('brokerage')}> Updated: {formatDateTime()} </Typography>
                    </Grid>
                </Grid>
            )}

            {/* Button */}
            {(Object.keys(data).length > 0) && (
                <Grid container item
                    sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', marginRight: isSmallScreen && '80px' }}
                >
                    <Grid item>
                        {/* onTouch added - srini - 09-01-25 */}
                        <Button className={classes.button} onTouchStart={() => handleSelectCard('transaction')}>Transactions</Button>
                    </Grid>
                </Grid>
            )}
            {/* search field srini - 21-01-25 */}
            <Box sx={{ width: '100%', marginTop: '15px' }}>
                {/* Search Box */}
                {displayData.length > 0 && (
                    <Box sx={{marginRight: isSmallScreen && '80px'}}>
                        <Box sx={{ marginBottom: '10px', textAlign: 'center' }}>
                            <TextField
                                value={searchQuery}
                                onChange={handleSearchChange}
                                placeholder="Search..."
                                variant="outlined"
                                size="small"
                                className={classes.srchFldTxt}
                            />
                        </Box>
                    </Box>
                )}

                <Grid container item>
                    {['completed', 'in_progress'].map((cardType) => (
                        selectedCard === cardType && displayData.length > 0 && (
                            <Box key={cardType} sx={{ width: cardType === 'completed' ? "90%" : "90%", marginTop: '20px', background: '#131E2E', overflowX: 'hidden' }}>
                                {/* updated by srini on 20-01-25 */}
                                <Grid container ref={tableRef}>
                                    <List sx={{ width: "100%" }}>
                                        {/* Render the header only once for 'completed' */}
                                        {cardType === 'completed' && (
                                            <ListItem sx={{ display: "flex", flexDirection: "column", alignItems: "start", borderBottom: "2px solid #000000" }}>
                                                <ListItemText sx={{ width: "100%" }}
                                                    primary={
                                                        <Box display="flex">
                                                            <Grid item xs={4}>
                                                                <Typography className={classes.listPrimaryText}>Date</Typography>
                                                            </Grid>
                                                            <Grid item xs={8} sx={{ display: 'flex', justifyContent: 'flex-end' }}>
                                                                <Typography className={classes.listPrimaryText}>No of Clients Onboarded</Typography>
                                                            </Grid>
                                                        </Box>
                                                    }
                                                />
                                            </ListItem>
                                        )}

                                        {/* Render the rows based on data */}
                                        {displayData.map((item, index) => (
                                            <ListItem key={index} sx={{ display: "flex", flexDirection: "column", alignItems: "start", borderBottom: "2px solid #000000" }}>
                                                {/* List Header */}
                                                <ListItemText sx={{ width: "100%" }}
                                                    primary={
                                                        <Box display="flex">
                                                            {cardType === 'in_progress' && (
                                                                <>
                                                                    <Grid item xs={8}>
                                                                        <Typography className={classes.listPrimaryText}>Email</Typography>
                                                                    </Grid>
                                                                    <Grid item xs={4}>
                                                                        <Typography className={classes.listPrimaryText}>Phone</Typography>
                                                                    </Grid>
                                                                </>
                                                            )}
                                                        </Box>
                                                    }
                                                    secondary={
                                                        <Box display="flex">
                                                            {cardType === 'completed' ? (
                                                                <>
                                                                    <Grid item xs={6}>
                                                                        {/* added by srini on 16-01-25 */}
                                                                        <Typography className={classes.listSecondaryText}>{item?.last_activity_date || '-'}</Typography>
                                                                    </Grid>
                                                                    <Grid item xs={6} sx={{ display: 'flex', justifyContent: 'center' }}>
                                                                        <Typography className={classes.listSecondaryText}>{item?.no_of_account || '-'}</Typography>
                                                                    </Grid>
                                                                </>
                                                            ) : (
                                                                <>
                                                                    <Grid item xs={8}>
                                                                        <Typography className={classes.listSecondaryText}>{item?.email}</Typography>
                                                                    </Grid>
                                                                    <Grid item xs={4}>
                                                                        <Typography className={classes.listSecondaryText}>{item?.phone}</Typography>
                                                                    </Grid>
                                                                </>
                                                            )}
                                                        </Box>
                                                    }
                                                />
                                                {/* Secondary Information for in_progress */}
                                                {cardType === 'in_progress' && (
                                                    <ListItemText sx={{ width: "100%" }}
                                                        primary={
                                                            <Box display="flex">
                                                                <Grid item xs={8}>
                                                                    <Typography className={classes.listPrimaryText}>Stage</Typography>
                                                                </Grid>
                                                                <Grid item xs={4}>
                                                                    <Typography className={classes.listPrimaryText}>Call</Typography>
                                                                </Grid>
                                                            </Box>
                                                        }
                                                        secondary={
                                                            <Box display="flex">
                                                                <Grid item xs={8}>
                                                                    {/* srini - 22-01-25 */}
                                                                    <Typography className={classes.stageText}>{item?.stage || '-'}</Typography>
                                                                </Grid>
                                                                <Grid item xs={4}>
                                                                    <a href={`tel:${item?.phone}`} style={{ textDecoration: 'none' }}>
                                                                        <img
                                                                            src={Vector1}
                                                                            alt='phone icon'
                                                                            style={{ marginTop: '5px', width: '18px', height: '18px' }}
                                                                        />
                                                                    </a>
                                                                </Grid>
                                                            </Box>
                                                        }
                                                    />
                                                )}

                                                {/* Third Information for in_progress */}
                                                {cardType === 'in_progress' && (
                                                    <ListItemText sx={{ width: "100%" }}
                                                        primary={
                                                            <Box display="flex">
                                                                <Grid item xs={8}>
                                                                    <Typography className={classes.listPrimaryText}>Acop</Typography>
                                                                </Grid>
                                                                <Grid item xs={4}>
                                                                    <Typography className={classes.listPrimaryText}>Last Activity</Typography>
                                                                </Grid>
                                                            </Box>
                                                        }
                                                        secondary={
                                                            <Box display="flex">
                                                                <Grid item xs={8} >
                                                                    <Typography className={classes.listSecondaryText}>
                                                                        {item?.created_on?.split('T')[0] || '-'} <br />
                                                                        {item?.created_on?.split('T')[1]?.split('.')[0] || '-'}
                                                                    </Typography>
                                                                </Grid>
                                                                <Grid item xs={4}>
                                                                    <Typography className={classes.listSecondaryText}>
                                                                        {item?.updated_on?.split('T')[0] || '-'} <br />
                                                                        {item?.updated_on?.split('T')[1]?.split('.')[0] || '-'}
                                                                    </Typography>
                                                                </Grid>
                                                            </Box>
                                                        }
                                                    />
                                                )}
                                            </ListItem>
                                        ))}
                                    </List>
                                </Grid>

                                {/* Pagination container */}
                                <Grid sx={{ display: "flex", justifyContent: "center", alignItems: "center", background: '#131E2E', color: '#fff', marginTop: '5px', marginBottom: '6px' }}>
                                    <Pagination
                                        showFirstButton
                                        showLastButton
                                        count={Math.ceil(totalCount/ 10)}
                                        size="small"
                                        page={mPage}
                                        onChange={handlePageChange}
                                        sx={{
                                            '& .MuiPaginationItem-root': {
                                                color: 'white',
                                            },
                                            '& .MuiPaginationItem-ellipsis': {
                                                color: 'white',
                                            },
                                            '& .MuiPaginationItem-root.Mui-selected': {
                                                backgroundColor: '#999',
                                                color: 'white',
                                                fontWeight: 'bold',
                                            }
                                        }}
                                    />
                                </Grid>
                            </Box>
                        )
                    ))}
                </Grid>

                <Grid container item sx={{ textAlign: 'center' }}>
                    {['brokerage', 'transaction'].map((cardType) => (
                        selectedCard === cardType && displayData.length > 0 && (
                            <Box key={cardType} sx={{ width: cardType === 'brokerage' ? "90%" : "90%", marginTop: '10px', background: '#131E2E' }}>
                                {/* updated by srini on 20-01-25 */}
                                <Grid container ref={tableRef}>
                                    <List sx={{ width: "100%" }}>
                                        {/* Render the header only once for 'completed' */}
                                        {cardType === 'brokerage' && (
                                            <ListItem sx={{ display: "flex", flexDirection: "column", alignItems: "start", borderBottom: "2px solid #000000" }}>
                                                <ListItemText sx={{ width: "100%" }}
                                                    primary={
                                                        <Box display="flex">
                                                            <Grid item xs={6}>
                                                                <Typography className={classes.listPrimaryText}>Date</Typography>
                                                            </Grid>
                                                            <Grid item xs={6} sx={{ display: 'flex', justifyContent: 'center' }}>
                                                                <Typography className={classes.listPrimaryText}>Brokerage</Typography>
                                                            </Grid>
                                                        </Box>
                                                    }
                                                />
                                            </ListItem>
                                        )}

                                        {/* Render the rows based on data */}
                                        {displayData.map((item, index) => (
                                            <ListItem key={index} sx={{ display: "flex", flexDirection: "column", alignItems: "start", borderBottom: "2px solid #000000" }}>
                                                {/* List Header */}
                                                <ListItemText
                                                    sx={{ width: "100%" }}
                                                    primary={
                                                        <Box display="flex">
                                                            {cardType === 'transaction' && (
                                                                <>
                                                                    <Grid item xs={4}>
                                                                        <Typography className={classes.listPrimaryText}>UCC</Typography>
                                                                    </Grid>
                                                                    <Grid item xs={5}>
                                                                        <Typography className={classes.listPrimaryText}>Ledger Balance</Typography>
                                                                    </Grid>
                                                                    <Grid item xs={4}>
                                                                        <Typography className={classes.listPrimaryText}>Last Traded</Typography>
                                                                    </Grid>
                                                                </>
                                                            )}
                                                        </Box>
                                                    }
                                                    secondary={
                                                        <Box display="flex">
                                                            {cardType === 'brokerage' ? (
                                                                <>
                                                                    <Grid item xs={6}>
                                                                        <Typography className={classes.listSecondaryText}>{item?.trading_date}</Typography>
                                                                    </Grid>
                                                                    <Grid item xs={6} sx={{ display: 'flex', justifyContent: 'center' }}>
                                                                        <Typography className={classes.listSecondaryText}>{item?.brokerage?.toFixed(2)}</Typography>
                                                                    </Grid>
                                                                </>
                                                            ) : (
                                                                <>
                                                                    <Grid item xs={4}>
                                                                        <Typography marginRight="15px" className={classes.listSecondaryText}>{item?.client_id}</Typography>
                                                                    </Grid>
                                                                    <Grid item xs={5}>
                                                                        <Typography className={classes.listSecondaryText}>{item?.available_margin || '-'}</Typography>
                                                                    </Grid>
                                                                    <Grid item xs={4}>
                                                                        <Typography className={classes.listSecondaryText}>{item?.lasttrade_date || '-'}</Typography>
                                                                    </Grid>
                                                                </>
                                                            )}
                                                        </Box>
                                                    }
                                                />

                                                {/* Secondary Information for Transaction */}
                                                {cardType === 'transaction' && (
                                                    <ListItemText
                                                        sx={{ width: "100%" }}
                                                        primary={
                                                            <Box display="flex">
                                                                <Grid item xs={4}>
                                                                    <Typography className={classes.listPrimaryText}>Invested</Typography>
                                                                </Grid>
                                                                <Grid item xs={5}>
                                                                    <Typography className={classes.listPrimaryText}>Current Value</Typography>
                                                                </Grid>
                                                                <Grid item xs={4}>
                                                                    <Typography className={classes.listPrimaryText}>P&L</Typography>
                                                                </Grid>
                                                            </Box>
                                                        }
                                                        secondary={
                                                            <Box display="flex">
                                                                <Grid item xs={4}>
                                                                    <Typography className={classes.listSecondaryText}>{item?.invested || '-'}</Typography>
                                                                </Grid>
                                                                <Grid item xs={5}>
                                                                    <Typography className={classes.listSecondaryText}>{item?.current}</Typography>
                                                                </Grid>
                                                                <Grid item xs={4}>
                                                                    <Typography
                                                                        sx={{
                                                                            color:
                                                                                item?.profit_notional === 0
                                                                                    ? '#fff'
                                                                                    : parseFloat(item?.profit_notional) < 0
                                                                                        ? '#ff0400'
                                                                                        : '#adff00',
                                                                        }}
                                                                    >
                                                                        {item?.profit_notional === null || item?.profit_notional === undefined
                                                                            ? '-'
                                                                            : item?.profit_notional === 0
                                                                                ? '0'
                                                                                : parseFloat(item?.profit_notional) <= 0
                                                                                    ? new Intl.NumberFormat('en-IN').format(parseFloat(item?.profit_notional).toFixed(2))
                                                                                    : `+${new Intl.NumberFormat('en-IN').format(parseFloat(item?.profit_notional).toFixed(2))}`}
                                                                    </Typography>
                                                                </Grid>
                                                            </Box>
                                                        }
                                                    />
                                                )}
                                            </ListItem>
                                        ))}
                                    </List>
                                </Grid>

                                {/* Pagination container */}
                                <Grid sx={{ display: "flex", justifyContent: "center", alignItems: "center", background: '#131E2E', color: '#fff', marginTop: '5px', marginBottom: '6px' }}>
                                    <Pagination
                                        showFirstButton
                                        showLastButton
                                        count={Math.ceil(totalCount / 10)}
                                        size="small"
                                        page={mPage}
                                        onChange={handlePageChange}
                                        sx={{
                                            '& .MuiPaginationItem-root': {
                                                color: 'white',
                                            },
                                            '& .MuiPaginationItem-ellipsis': {
                                                color: 'white',
                                            },
                                            '& .MuiPaginationItem-root.Mui-selected': {
                                                backgroundColor: '#999',
                                                color: 'white',
                                                fontWeight: 'bold',
                                            }
                                        }}
                                    />
                                </Grid>
                            </Box>
                        )
                    ))}
                </Grid>
            </Box>
        </Grid>

    )

}

export default withStyles(styles)(WebView)